/**
 * Ryan O'Dowd
 * 2026-01-10
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
const getStyles = () => {
  return {
    compactContentStyles: {
      padding: 0,
      margin: 0,
    },
  };
};

export default getStyles;
